import React, { useState, useEffect } from 'react';
import * as S from './styles';
import api from '../../services/api';
import { notifyApiError } from '../../services/apiError';
import Badge from '../badge';
import { theme } from '../../styles/theme';
import IconWarningOrange from '../../assets/icons/icon-warning-orange.png';
import { Loading } from '../loading';

const RankingReport = ({ dtInicial, dtFinal, periodoLabel, ...props }) => {
    const [topFazendas, setTopFazendas] = useState(null);
    const [fazendasInativas, setFazendasInativas] = useState(null);

    const searchInitialData = async () => {
        setTopFazendas(null);
        setFazendasInativas(null);

        try {
            const response = await api.get('/relatorio/ranking-produtores', {
                params: { dtInicial, dtFinal },
            });

            setTopFazendas(response.data.data.topFazendas || []);
            setFazendasInativas(response.data.data.fazendasInativas || []);
        } catch (error) {
            notifyApiError(error, 'Falha ao carregar ranking de produtores.');
            setTopFazendas([]);
            setFazendasInativas([]);
        }
    }

    useEffect(() => {
        searchInitialData();
    }, [dtInicial, dtFinal])

    const loadingBox = (
        <S.LoadingBox>
            <Loading size="32px" color={theme.colors.green.Bandeira} noMargin />
        </S.LoadingBox>
    );

    return (
        <S.Container>
            <S.Title>Ranking de produtores</S.Title>

            <S.Cols>
                <S.Col>
                    <S.ColLabel>Top produtores por receitas emitidas</S.ColLabel>

                    {topFazendas === null ? (
                        loadingBox
                    ) : topFazendas.length === 0 ? (
                        <S.ItemSubtitle>Nenhuma receita emitida no período selecionado.</S.ItemSubtitle>
                    ) : topFazendas.map((item) => (
                        <S.Item key={item.nome}>
                            <S.ItemInfo>
                                <S.ItemName>{item.nome}</S.ItemName>
                                <S.ItemSubtitle>{item.areaTratada} ha tratados</S.ItemSubtitle>
                            </S.ItemInfo>
                            <S.ItemValue>{item.totalReceitas} receitas</S.ItemValue>
                        </S.Item>
                    ))}
                </S.Col>

                <S.Col>
                    <S.ColLabel>Sem receita emitida há mais de 60 dias</S.ColLabel>

                    {fazendasInativas === null ? (
                        loadingBox
                    ) : fazendasInativas.length === 0 ? (
                        <S.ItemSubtitle>Nenhuma fazenda inativa.</S.ItemSubtitle>
                    ) : fazendasInativas.map((item) => (
                        <S.Item key={item.nome}>
                            <S.ItemInfo>
                                <S.ItemName>{item.nome}</S.ItemName>
                                <S.ItemSubtitle>última receita: {item.diasSemReceita} dias atrás</S.ItemSubtitle>
                            </S.ItemInfo>
                            {item.clienteInativo && (
                                <Badge
                                    color={theme.colors.orange.fundo}
                                    textColor={theme.colors.orange.Laranja}
                                    icon={IconWarningOrange}
                                >
                                    Inativo
                                </Badge>
                            )}
                        </S.Item>
                    ))}
                </S.Col>
            </S.Cols>
        </S.Container>
    )
}

export default RankingReport;
